import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, takeUntil, withLatestFrom } from 'rxjs';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { Select, ofActionSuccessful } from '@ngxs/store';

import { NgxsActionName, NgxsFormPath, SelectItems } from '@app/shared/constants';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { KpiITToolUsage } from '@app/shared/classes/kpi-it-tool-usage';
import * as AppDataAction from '@app/shared/actions/app-data.action';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { SpinnerButtonComponent } from '@shared/components/spinner-button/spinner-button.component';
import { InjectDialogData } from '@shared/components/edit-modal-dialog/edit-modal-dialog.constant';
import { WebApiResponseBase } from '@app/shared/classes/general';
import { EditModalDialogBasedComponent } from '@shared/components/edit-modal-dialog/edit-modal-dialog.based.component';
import { SiteConfigHelper } from '@app/shared/utils/site-config.helper';

@Component({
  selector: 'it-tool-usage-edit-modal-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SpinnerButtonComponent, TranslateModule, NgxsFormPluginModule, ReactiveFormsModule, MatDialogModule, AngularMaterialModule],
  templateUrl: './it-tool-usage-edit-modal-dialog.component.html',
  styleUrl: './it-tool-usage-edit-modal-dialog.component.css'
})
export class ITToolUsageEditModalDialogComponent extends EditModalDialogBasedComponent<ITToolUsageEditModalDialogComponent, KpiITToolUsage> {
  complianceSelectItems = SelectItems.complianceSelectItems;

  formPath = NgxsFormPath.KPI_IT_TOOL_USAGE_EDIT_FORM;
  isOccurrenceTargetEditable = true;

  @Select(AppDataState.taskExecuting(NgxsActionName.UPDATE_KPI_IT_TOOL_USAGE)) updating$: Observable<boolean>;
  @Select(AppDataState.taskError(NgxsActionName.UPDATE_KPI_IT_TOOL_USAGE)) response$: Observable<WebApiResponseBase>;

  constructor(public dialogRef: MatDialogRef<ITToolUsageEditModalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InjectDialogData<KpiITToolUsage>) {
    super();
    this.dataInit(dialogRef, data);
    this.initForm(data);
  }

  initForm = (data: InjectDialogData<KpiITToolUsage>) => {
    this.isOccurrenceTargetEditable = SiteConfigHelper.IsOccurrenceTargetEditableKPIs(data.data.kpi.kpiId);
    if (this.isOccurrenceTargetEditable) {
      this.editForm = this.formBuilder.group({
        kpiId: data.data.kpi.kpiId,
        compliance: data.data.compliance,
        occurrence: [data.data.occurrence, Validators.required],
        targetOccurrence: [data.data.targetOccurrence, Validators.required],
      });
    }
    else {
      this.editForm = this.formBuilder.group({
        kpiId: data.data.kpi.kpiId,
        compliance: data.data.compliance
      });
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    this.actions$.pipe(ofActionSuccessful(AppDataAction.UpdateKpiITToolUsage), withLatestFrom(this.response$), takeUntil(this.destroy$)).subscribe(
      ([_, errorResponse]) => this.processAfterUpdateObject(errorResponse));
  }

  onOkClick = () => {
    this.store.dispatch(new AppDataAction.UpdateKpiITToolUsage(this.data.data));
  }
}
